import {createElement as h} from "react";

import {cs}       from "../chain-services";
import {UseState} from "../use-state";

import {TaskRunner} from "./task-runner";

export const AsyncQueue = ({data, disabled=false, onUpdated=undefined, next}) => cs(
    ["pendingQueue", (_, next) => UseState({initValue: [], next})],
    ["activeAction", (_, next) => UseState({next})],

    ["taskRunner", ({activeAction, pendingQueue}, next) => h(TaskRunner, {
        action: !disabled && activeAction.value && (() => {
            return activeAction.value.action.action(data.value);
        }),
        onDone: (result) => {

            if (pendingQueue.value.length) {
                const [first, ...remaining] = pendingQueue.value;
                activeAction.onChange(first);
                pendingQueue.onChange(remaining);
            } else {
                activeAction.onChange(null);
            }
            let newData = data.value;
            if (result.change) {
                newData = result.change(newData);
                onUpdated?.(newData);
                data.onChange(newData);
            }

            if (result.error) {
                // noinspection JSIgnoredPromiseFromCall
                activeAction.value.reject(result.error);
            } else {
                activeAction.value.resolve(newData);
            }
        },
        next,
    })],
    ({pendingQueue, activeAction}) => next({
        active: !!activeAction.value,
        pushAction: (action) => {
            return new Promise((resolve, reject) => {
                if (!activeAction.value) {
                    activeAction.onChange({action, resolve, reject});
                } else {
                    pendingQueue.onChange([
                        ...pendingQueue.value,
                        {action, resolve, reject},
                    ]);
                }
            });
        },
    }),
);



